import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/park/coupon/used/page/v2', Object.assign({}, options, {
    params
  }));

export const getDiscountAmount = (params, options) =>
  request.get('/api/v4ward/park/coupon/used/totalAmount/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/park/coupon/used/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/park/coupon/used/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/park/coupon/used/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/park/coupon/used/submit/v2', params, options);
